module.exports = __webpack_public_path__ + "img/vue1-toebox_gris.8d556926.png";